
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["w-5 h-5",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_43_814)"}},[_c('path',{attrs:{"d":"M4.38833 8.6375C4.77823 7.45787 5.53071 6.43151 6.53842 5.70483C7.54613 4.97815 8.7576 4.58828 9.99999 4.59083C11.4083 4.59083 12.6817 5.09083 13.6817 5.90917L16.5917 3C14.8183 1.45417 12.5458 0.5 9.99999 0.5C6.05833 0.5 2.66499 2.74833 1.03333 6.04167L4.38833 8.6375Z","fill":"#EA4335"}}),_c('path',{attrs:{"d":"M13.3667 15.5108C12.4584 16.0967 11.3051 16.4092 10.0001 16.4092C8.76261 16.4117 7.55572 16.025 6.55025 15.3036C5.54478 14.5823 4.79167 13.563 4.39755 12.39L1.03088 14.9458C1.85692 16.6178 3.13527 18.0245 4.72074 19.0063C6.3062 19.9881 8.13522 20.5056 10.0001 20.5C12.4442 20.5 14.7792 19.6308 16.5284 18L13.3676 15.5108H13.3667Z","fill":"#34A853"}}),_c('path',{attrs:{"d":"M16.5283 18C18.3575 16.2933 19.545 13.7533 19.545 10.5C19.545 9.90831 19.4542 9.27247 19.3183 8.68164H10V12.5458H15.3633C15.0992 13.845 14.3883 14.8508 13.3675 15.5108L16.5283 18Z","fill":"#4A90E2"}}),_c('path',{attrs:{"d":"M4.39748 12.39C4.1936 11.7807 4.09003 11.1424 4.09081 10.5C4.09081 9.84829 4.19498 9.22246 4.38831 8.63746L1.03331 6.04163C0.346957 7.4272 -0.00685536 8.95372 -2.50248e-05 10.5C-2.50248e-05 12.1 0.370808 13.6083 1.03081 14.9458L4.39748 12.39Z","fill":"#FBBC05"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_43_814"}},[_c('rect',{attrs:{"width":"20","height":"20","fill":"white","transform":"translate(0 0.5)"}})])])])
          )
        }
      }
    